export default __webpack_public_path__ + "static/media/0.31da962b.jpg";